<h1 class="am-flex color-title-grey pl-s pb-s text-xl text-mobile-l">Kurzfristiger Personalbedarf ?</h1>

<swiper-container class="width-full" [config]="swiperOptions" swiper>
  @if (candidatesService.loading || candidates?.length) {
    @for (item of (candidatesService.loading ? $any([1, 2, 3, 4]) : candidates); track item) {
      <swiper-slide>
        @if (candidatesService.loading) { <candidate-card [item]="null" [loading]="true"                   ></candidate-card> }
        @else                           { <candidate-card [item]="item" (click)="trackCandidateClick(item)"></candidate-card> }
        <div class="spacer"></div>
      </swiper-slide>
    }
  } @else { <p class="flex-1 am-flex-center mt5 mb10 height-full p-m">Es wurden keine verfügbaren Profile gefunden.</p> }
</swiper-container>
